import type { ResourceState } from '@domain/schemas/contract.schema';
import { ArchiveIcon, BadgeCheckIcon, BookmarkAltIcon, BriefcaseIcon, PencilAltIcon } from '@heroicons/react/outline';
import { CheckIcon } from '@heroicons/react/solid';

export const getIconForStatus = (status: string) => {
  switch (status) {
    case 'FIRM_ORDER':
      return <BriefcaseIcon className="h-5 w-5" aria-hidden="true" />;

    case 'FINAL':
      return <BookmarkAltIcon className="h-5 w-5" aria-hidden="true" />;

    case 'ARCHIVED':
      return <ArchiveIcon className="h-5 w-5" aria-hidden="true" />;

    case 'DRAFT':
      return <PencilAltIcon className="h-5 w-5" aria-hidden="true" />;

    case 'REVIEW':
      return <BadgeCheckIcon className="h-5 w-5" aria-hidden="true" />;

    default:
      return <CheckIcon className="h-5 w-5" aria-hidden="true" />;
  }
};

// We only need the `Admin Only` badge on transitions from `FINAL` status
export const getShouldShowAdminOnlyBadge = (currentStatus?: ResourceState, isSelected?: boolean) => {
  if (isSelected) {
    return false;
  }

  return currentStatus === 'FINAL';
};
